import Dashboard from './DashboardScreen';
export default Dashboard;
